exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#omni-chat-web body {\n  margin: 0;\n  padding: 0;\n  font-family: 'Rawline', 'Raleway', sans-serif; }\n\n#omni-chat-web #captcha {\n  display: none; }\n\n#omni-chat-web .load-auth {\n  display: -ms-flexbox;\n  display: flex;\n  height: 100vh;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n#omni-chat-web .load-auth .helper-text {\n  font-family: \"Rawline\", \"Raleway\", sans-serif !important;\n  margin-top: 15px; }\n", ""]);

// exports
